import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import Button from 'react-bootstrap/Button';
import { ingredientValidationSchema } from '../../validations-modules/ingredient.js'

import { FieldsIngredientDetails } from '../fields-ingredient/FieldsIngredientDetails.js'

export const FormIngredientDetails = ({ formData, setFormData, nextStep }) => {

  return (
    <>
      <Formik
        initialValues={formData}

        onSubmit={(values, {setSubmitting, resetForm}) => {
            // When button submits form and form is in the process of submitting, submit button is disabled
            setSubmitting(true);
            
            setFormData(prev => {
              return {...prev, ...values}
            });

            // Resets form after submission is complete
            resetForm();

            // Sets setSubmitting to false after form is reset
            setSubmitting(false);

            nextStep();
        }}

        validationSchema={ingredientValidationSchema}
      >
        
        {({ isSubmitting, errors, touched, values, resetForm, handleSubmit, setFieldValue, setFieldTouched }) => 
        (
          <FieldsIngredientDetails handleSubmit={handleSubmit} touched={touched} errors={errors} values={values} setFieldValue={setFieldValue} setFieldTouched={setFieldTouched}>        
              <Button
              type='submit'
              variant='primary'
              disabled={isSubmitting}>
            
              Avanti
            </Button>
          </FieldsIngredientDetails>
        )}
      </Formik>
    </>
  );
};

FormIngredientDetails.propTypes = {
  formData: PropTypes.object.isRequired,
  setFormData: PropTypes.func.isRequired,
  nextStep: PropTypes.func.isRequired
};